import { styled } from '@/styled-system/jsx'

export const Ul = styled('ul', {
  base: {
    listStyle: 'disc',
    paddingLeft: 1,
  },
})
